import React from 'react';
import {
  Row,
} from 'react-bootstrap';
import { routerProps } from '../../propTypes';
import TicketListEnhanced from './components/TicketNumberListEnhanced';
import TicketNumberSummaryEnhanced from './components/TicketNumberSummaryEnhanced';
import TicketNumberGroup from '../ticketNumberGroup/page';
import './style.css';
import PageLayout from '../../layouts/PageLayout';
import SplitLayout from '../../layouts/SplitLayout';

const proptypes = {
  ...routerProps,
};

const TicketStatus = (props) => {
  return (
    <PageLayout
      title="Missing Tickets"
      render={() => {
        return (
          <div>
            <SplitLayout
              leftSize={4}
              leftRender={() => {
                return (
                  <div>
                    <TicketListEnhanced />
                  </div>
                );
              }}
              rightSize={8}
              rightRender={() => {
                return (
                  <div>
                    <Row>
                      <div className="col-xs-3">
                        <TicketNumberGroup />
                      </div>
                    </Row>
                    <hr className="border-black" />
                    <TicketNumberSummaryEnhanced />
                  </div>
                );
              }}
            />
          </div>
        );
      }}
    />
  );
};


TicketStatus.propTypes = proptypes;
export default TicketStatus;
